module.exports = __webpack_public_path__ + "static/media/ZSCE_TP_TROCA.ddac07eb.pdf";